const ProformaReportReducer = (state, action) => {
  switch (action.type) {
    case "PROCESS_START":
      return {
        ...state,
        loading: true,
        proformas: [],
        totalAmount: 0,
        totalVat: 0,
        count: 0,
        error: null,
      };

    case "FETCH_PROFORMA_RECORDS":
      return {
        ...state,
        loading: false,
        proformas: action.payload.data,
        totalAmount: action.payload.totalAmount,
        totalVat: action.payload.totalVat,
        count: action.payload.count,
        error: null,
      };

    case "PROCESS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
        proformas: []
      };

    case "FETCH_CLIENT_RECORD":
      return {
        ...state,
        clients: action.payload.data,
      };

    default:
      return state;
  }
};

export default ProformaReportReducer;